import React, { useState } from 'react';
import StorageOutlinedIcon from '@mui/icons-material/StorageOutlined';
import { Button } from '@mui/material';
import { useNavigate } from 'react-router-dom';
import FullPageState from './FullPageState';
import RegisterPicker from './RegisterPicker';
import { clearRegisterSession } from '../utils/registerSession';

function DatabaseExpired({ fullViewport = false }) {
  const navigate = useNavigate();
  const [pickerOpen, setPickerOpen] = useState(false);

  const handleGoToLogin = () => {
    clearRegisterSession();
    navigate('/login', { replace: true });
    window.location.href = '/login';
  };

  return (
    <>
    <FullPageState
      fullViewport={fullViewport}
      icon={<StorageOutlinedIcon fontSize="inherit" />}
      eyebrow="Register unavailable"
      statusLabel="Subscription inactive"
      title="Database expired"
      description="Your database subscription has expired. Please contact the system administrator to renew your subscription."
      supportingText="Your register data remains unavailable until an administrator renews access."
      actions={(
        <>
          {localStorage.getItem('token') && <Button className="full-page-state__primary-action" variant="contained" disableElevation onClick={() => setPickerOpen(true)}>Change Register</Button>}
          <Button
            className="full-page-state__secondary-action"
            variant="outlined"
            disableElevation
            onClick={handleGoToLogin}
          >
            Go to Login
          </Button>
          <Button
            className="full-page-state__secondary-action"
            variant="outlined"
            onClick={() => { window.location.href = 'mailto:hasanovicsanjin@gmail.com'; }}
          >
            Contact Admin
          </Button>
        </>
      )}
    />
    <RegisterPicker open={pickerOpen} onClose={() => setPickerOpen(false)} />
    </>
  );
}

export default DatabaseExpired;
